const $ = jQuery;
const $trigger = $('.js-download-popup--trigger');

export default function () {
    if ($trigger.length === 0) {
        return;
    }

    handleTriggerClick();
    handleSubmit();
}

const handleTriggerClick = () => {
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.download-popup__inner').length) {
            closePopup();
        }
    });

    $(document).on('click', '.js-download-popup--trigger', function (e) {
        e.preventDefault();
        const $id = $(this).data('id');
        const files = $(this).data('files');

        if (files.length === 0) {
            return;
        }

        if (files.length === 1) {
            window.open(files[0].file, '_blank');
            return;
        }

        const $options = $('.js-download-popup-options');
        $options.empty();

        files.forEach((item, index) => {
            $options.append(createOption(item, index));
        });

        $('.js-download-popup-id').val($id);
        openPopup();

        e.stopPropagation();
    });
};

const createOption = (item, index) => {
    return `
    <div class="download-popup__option">
        <input type="checkbox" id="${item.name}-${index}" value="${item.file}">
        <label for="${item.name}-${index}">
            ${item.name}

            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewbox="0 0 14 15" fill="none">
                <rect x="0.5" y="1" width="13" height="13" stroke="#ACACAC"/>
                <rect x="3.5" y="4" width="7" height="7" fill="#0B828A" class="checkbox-fill"/>
            </svg>
        </label>
    </div>`;
};

const openPopup = () => {
    const $popup = $('.js-download-popup');
    $popup.show();
};

const closePopup = () => {
    const $popup = $('.js-download-popup');
    $popup.hide();
};

const handleSubmit = () => {
    $('.js-download-popup-submit').on('click', function (e) {
        e.preventDefault();
        const id = $('.js-download-popup-id').val();
        const $options = $('.js-download-popup-options');
        const $selectedOptions = $options.find(':checked');
        const data = $selectedOptions
            .map(function () {
                return {
                    title: $(this).attr('id'),
                    url: $(this).val(),
                };
            })
            .get();

        downloadFiles(data);
        clearCheckedOptions();
        closePopup();
    });
};

const clearCheckedOptions = () => {
    $('.js-download-popup-options').find(':checked').prop('checked', false);
};

const downloadFiles = (data) => {
    data.forEach((item, index) => {
        setTimeout(() => {
            downloadFile(item);
        }, index * 500); // Add 500ms delay between each download
    });
};

const areAllFilesPdf = (data) => {
    return data.every((item) => item.url.endsWith('.pdf'));
};

const downloadFile = (item) => {
    const anchor = document.createElement('a');
    anchor.href = item.url;
    anchor.download = item.title;
    anchor.click();
    anchor.remove();
};
